import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faMagnifyingGlass, faPlus, faUpload, faFileCsv, faTimes, faEye, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import '../App.css'
import api from '../api';

const ClienteManager = ({ currentUser }) => {
    const [clientes, setClientes] = useState([]);
    const [allClientes, setAllClientes] = useState([]); // Todos los clientes sin filtrar
    const [facturasResumen, setFacturasResumen] = useState([]);
    const [honorariosResumen, setHonorariosResumen] = useState([]);
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null) //    estado para el archivo CSV
    const [fileName, setFileName] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); // Buscador
    const [sortField, setSortField] = useState('nombre'); // Campo de ordenación
    const [sortOrder, setSortOrder] = useState('asc'); // Orden ascendente o descendente
    const [selectedCliente, setSelectedCliente] = useState(null); // Cliente seleccionado para editar
    const navigate = useNavigate();
    const { id, role } = currentUser || {}
    const [resumenCarga, setResumenCarga] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [totalPages, setTotalPages] = useState(1);
    // const limit = 25;
    const [error, setError] = useState(null);
    const [showClientsWithoutMovements, setShowClientsWithoutMovements] = useState(false);


    // Obtener clientes con saldos pendientes
    const fetchClientes = async () => {
        const token = localStorage.getItem('token');
        setLoading(true);
        try {
            // Obtenemos todos los clientes, sin paginación
            const response = await api.get('/clientes', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            
            setAllClientes(response.data);
            setError(null);
        } catch (error) {
            console.error(`Error al obtener clientes: ${error.message}`);
            setError('Error al cargar los clientes');
        } finally {
            setLoading(false);
        }
    };


    // Obtener resúmenes de facturas
    const fetchResumenFacturas = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await api.get('/facturas/resumen', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            //console.log('Resumen Facturas:', response.data.clientes);
            setFacturasResumen(response.data.clientes);
        } catch (err) {
            setError(err.response?.data?.message || 'Error al obtener resumen de facturas');
        }
    };

    // Obtener resúmenes de honorarios
    const fetchResumenHonorarios = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await api.get('/honorarios/resumen-honorarios', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            //console.log('Resumen Honorarios:', response.data.clientes);
            setHonorariosResumen(response.data.clientes);
        } catch (err) {
            console.error('Error en fetchResumenHonorarios:', err);
            setError(err.response?.data?.message || 'Error al obtener resumen de honorarios');
        }
    };


    useEffect(() => {
        fetchClientes();
        fetchResumenFacturas();
        fetchResumenHonorarios();
    }, []);

  
    // Función para formatear y normalizar RUTs
    const formatRut = (rut) => rut?.trim().toLowerCase() || '';


    // Función para asociar resúmenes a cada cliente y aplicar la ordenación
    useEffect(() => {
        // Procesar cuando tengamos clientes (honorarios puede estar vacío)
        if (allClientes.length > 0) {
            console.log("Procesando datos: clientes:", allClientes.length, "facturas:", facturasResumen.length, "honorarios:", honorariosResumen.length);
            
            const clientesConResumen = allClientes.map(cliente => {
                const clienteRutFormateado = formatRut(cliente.rut);
                const resumenFactura = facturasResumen.find(r => formatRut(r.clienteRut) === clienteRutFormateado) || {};
                const resumenHonorario = honorariosResumen.find(r => formatRut(r.clienteRut) === clienteRutFormateado) || {};
    
                return {
                    ...cliente,
                    abonosFacturas: resumenFactura.abonosFacturas || 0,
                    saldoPendienteFacturas: resumenFactura.saldoPendienteFacturas || 0,
                    abonosHonorarios: resumenHonorario.abonosHonorarios || 0,
                    saldoPendienteHonorarios: resumenHonorario.saldoPendienteHonorarios || 0,
                    cantidadFacturasPendientes: resumenFactura.cantidadFacturasPendientes || 0,
                    cantidadHonorariosPendientes: resumenHonorario.cantidadHonorariosPendientes || 0,
                    totalSaldoPendiente:
                        (resumenFactura.saldoPendienteFacturas || 0) +
                        (resumenHonorario.saldoPendienteHonorarios || 0),
                };
            });
    
            // Aplicar búsqueda
            let clientesFiltrados = clientesConResumen;
            if (searchTerm) {
                const searchRegex = new RegExp(searchTerm, 'i');
                clientesFiltrados = clientesFiltrados.filter(cliente => 
                    searchRegex.test(cliente.nombre) || searchRegex.test(cliente.rut)
                );
            }
    
            // Ordenar
            clientesFiltrados.sort((a, b) => {
                let valueA, valueB;
    
                // Manejar campos especiales
                if (sortField === 'totalSaldoPendiente') {
                    valueA = a.totalSaldoPendiente || 0;
                    valueB = b.totalSaldoPendiente || 0;
                } else if (sortField === 'saldoPendienteFacturas') {
                    valueA = a.saldoPendienteFacturas || 0;
                    valueB = b.saldoPendienteFacturas || 0;
                } else if (sortField === 'saldoPendienteHonorarios') {
                    valueA = a.saldoPendienteHonorarios || 0;
                    valueB = b.saldoPendienteHonorarios || 0;
                } else {
                    valueA = a[sortField] || '';
                    valueB = b[sortField] || '';
                }
    
                // Ordenar según tipo de dato
                if (typeof valueA === 'string') {
                    return sortOrder === 'asc' 
                        ? valueA.localeCompare(valueB) 
                        : valueB.localeCompare(valueA);
                } else {
                    return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
                }
            });
    
            console.log("Datos procesados correctamente, actualizando el estado con", clientesFiltrados.length, "clientes");
            setClientes(clientesFiltrados);
        } else {
            console.log("Esperando datos: clientes:", allClientes.length, "facturas:", facturasResumen.length, "honorarios:", honorariosResumen.length);
        }
    }, [allClientes, facturasResumen, honorariosResumen, sortField, sortOrder, searchTerm]);



    const filteredClientes = clientes.filter(cliente => {
        const tieneMovimientos = (cliente.cantidadFacturasPendientes > 0) || (cliente.cantidadHonorariosPendientes > 0);
        // Si está marcado el checkbox se muestran todos; de lo contrario, se muestran solo los que tienen movimientos.
        return showClientsWithoutMovements ? true : tieneMovimientos;
    });



    // Manejar la carga del archivo csv
    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // Guardar el archivo seleccionado
        setFileName(e.target.files[0].name); // Mostrar el nombre del archivo seleccionado
    };


    // Manejar ordenación
    const handleSortClick = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('asc');
        }
    };

    // Renderizar icono de ordenación
    const renderSortIcon = (field) => {
        if (sortField !== field) {
            return <FontAwesomeIcon icon={faSort} className="ml-1 text-gray-400" />;
        }
        return sortOrder === 'asc' 
            ? <FontAwesomeIcon icon={faSortUp} className="ml-1 text-blue-500" />
            : <FontAwesomeIcon icon={faSortDown} className="ml-1 text-blue-500" />;
    };


    // Eliminar cliente
    const handleDelete = (id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const token = localStorage.getItem('token');
                    await api.delete(`/clientes/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    setClientes(clientes.filter((cliente) => cliente._id !== id));
                    Swal.fire('Eliminado', 'El cliente ha sido eliminado.', 'success');
                } catch (err) {
                    console.error(err);
                    Swal.fire('Error', 'No se pudo eliminar el cliente.', 'error');
                }
            }
        });
    }




    // Enviar el archivo al backend
    const handleUpload = async () => {
        if (!file) {
            Swal.fire('Advertencia', 'Seleccione un archivo CSV', 'warning');
            return;
        }
        setUploading(true);
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await api.post('/clientes/upload', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Actualizar la lista de clientes
            await fetchClientes();

            // Mostrar resumen de la carga
            setResumenCarga(response.data);
            setModalIsOpen(true);

            Swal.fire('Éxito', 'Carga completada. Vea el resumen en el Modal.', 'success');
            setFile(null);
            setFileName('');
        } catch (error) {
            console.error('Error al cargar clientes:', error);
            Swal.fire('Error', 'No se pudieron cargar los clientes', 'error');
        } finally {
            setUploading(false);
        }
    };


    const closeModal = () => {
        setModalIsOpen(false);
        setResumenCarga(null);
    };



    // Función para actualizar el cliente
    const handleUpdateCliente = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        try {
            const response = await api.put(
                `/clientes/${selectedCliente._id}`,
                selectedCliente,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            // Actualizar la lista de clientes
            await fetchClientes();
            // Mostrar alerta de éxito
            Swal.fire('Actualizado', 'Cliente actualizado correctamente', 'success');
            // Cerrar el modal
            setSelectedCliente(null);
        } catch (error) {
            console.error('Error al actualizar el cliente:', error);
            Swal.fire('Error', 'No se pudo actualizar el cliente.', 'error');
        }
    };



    // Manejar cambio en el término de búsqueda
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        // setCurrentPage(1); // Resetear a la primera página cuando cambia la búsqueda
    };




    // Manejar la edición de cliente
    const handleEditClick = (cliente) => setSelectedCliente(cliente);

    const handleViewDetails = (rut) => {
        navigate(`/clientes/detalle/${rut}`);
    }



    return (
        <div className="p-4 bg-gray-100 min-h-screen">
            <h1 className="text-xl font-bold mb-3 text-center">Administrador de Clientes</h1>

            <div className="flex flex-col lg:flex-row gap-3 mb-3">
                {/* Panel de búsqueda y filtro */}
                <div className="flex-grow">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Buscar por nombre o RUT"
                            className="border border-gray-300 p-2 pl-10 rounded-md w-full"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <FontAwesomeIcon 
                            icon={faMagnifyingGlass} 
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
                        />
                    </div>
                </div>
                
                {/* Botón de nuevo cliente */}
                <div className="flex justify-end">
                    <button
                        onClick={() => navigate('/nuevo-cliente')}
                        className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md flex items-center"
                    >
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />
                        Nuevo Cliente
                    </button>
                </div>
            </div>
            
            {/* Checkbox para mostrar todos los clientes - mejorado visualmente */}
            <div className="flex justify-end mb-3">
                <label className="flex items-center space-x-3 text-base text-gray-700 cursor-pointer bg-white px-4 py-2 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
                        checked={showClientsWithoutMovements}
                        onChange={() => setShowClientsWithoutMovements(!showClientsWithoutMovements)}
                    />
                    <span className="font-medium">Mostrar clientes sin Saldo Pendiente</span>
                    <span className="text-sm text-gray-500">({filteredClientes.length} de {clientes.length})</span>
                </label>
            </div>

            {/* Carga masiva - reducido */}
            <div className="mb-4 bg-white p-3 rounded-lg shadow-sm">
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-medium text-gray-800">Carga masiva</h2>
                    <div className="flex items-center gap-2">
                        <label className="bg-gray-200 text-gray-700 rounded-md px-3 py-1 text-sm cursor-pointer hover:bg-gray-300">
                            <FontAwesomeIcon icon={faFileCsv} className="mr-1" />
                            CSV
                            <input
                                type="file"
                                accept=".csv"
                                onChange={handleFileChange}
                                className="hidden"
                            />
                        </label>
                        <button
                            onClick={handleUpload}
                            className="bg-blue-500 text-white rounded-md px-3 py-1 text-sm flex items-center hover:bg-blue-600"
                            disabled={uploading}
                        >
                            <FontAwesomeIcon icon={faUpload} className="mr-1" />
                            {uploading ? 'Cargando...' : 'Cargar'}
                        </button>
                        {fileName && <span className="text-xs text-gray-600 ml-2">{fileName}</span>}
                    </div>
                </div>
            </div>

            {/* Tabla de clientes */}
            <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
                <table className="min-w-full">
                    <thead>
                        <tr className="bg-gray-200 text-gray-700 uppercase text-sm tracking-wider">
                            <th className="py-3 px-3 text-left cursor-pointer hover:bg-gray-300" 
                            onClick={() => handleSortClick('nombre')}
                            style={{ width: '30%' }}>

                                <div className="flex items-center">
                                    Nombre
                                    {renderSortIcon('nombre')}
                                </div>
                            </th>
                            <th className="py-3 px-3 text-left" style={{ width: '15%' }}>RUT</th>
                            <th className="py-3 px-3 text-left cursor-pointer hover:bg-gray-300" onClick={() => handleSortClick('saldoPendienteFacturas')} style={{ width: '17%' }}>
                                <div className="flex items-center">
                                    Saldo Facturas
                                    {renderSortIcon('saldoPendienteFacturas')}
                                </div>
                            </th>
                            <th className="py-3 px-3 text-left cursor-pointer hover:bg-gray-300" onClick={() => handleSortClick('saldoPendienteHonorarios')} style={{ width: '17%' }}>
                                <div className="flex items-center">
                                    Saldo Honorarios
                                    {renderSortIcon('saldoPendienteHonorarios')}
                                </div>
                            </th>
                            <th className="py-3 px-3 text-left cursor-pointer hover:bg-gray-300" onClick={() => handleSortClick('totalSaldoPendiente')} style={{ width: '11%' }}>
                                <div className="flex items-center">
                                    Total Saldo
                                    {renderSortIcon('totalSaldoPendiente')}
                                </div>
                            </th>
                            <th className="py-3 px-3 text-center" style={{ width: '10%' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 text-sm">
                        {loading ? (
                            <tr>
                                <td colSpan="6" className="text-center py-4">
                                    <div className="flex justify-center items-center">
                                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mr-2"></div>
                                        Cargando...
                                    </div>
                                </td>
                            </tr>
                        ) : error ? (
                            <tr>
                                <td colSpan="6" className="text-center py-4 text-red-500">{error}</td>
                            </tr>
                        ) : filteredClientes.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center py-4">No hay clientes encontrados.</td>
                            </tr>
                        ) : (
                            filteredClientes.map(cliente => (
                                <tr
                                    key={cliente._id}
                                    className="border-b border-gray-200 hover:bg-gray-50"
                                >
                                    <td className="py-3 px-3">{cliente.nombre}</td>
                                    <td className="py-3 px-3">{cliente.rut}</td>
                                    <td className="py-3 px-3">
                                        <div className="flex items-center">
                                            <span>{cliente.saldoPendienteFacturas?.toLocaleString('es-CL') || '0'}</span>
                                            {cliente.cantidadFacturasPendientes > 0 && (
                                                <span className="ml-2 bg-blue-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
                                                    {cliente.cantidadFacturasPendientes}
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 px-3">
                                        <div className="flex items-center">
                                            <span>{cliente.saldoPendienteHonorarios?.toLocaleString('es-CL') || '0'}</span>
                                            {cliente.cantidadHonorariosPendientes > 0 && (
                                                <span className="ml-2 bg-green-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
                                                    {cliente.cantidadHonorariosPendientes}
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 px-3 font-semibold">
                                        {cliente.totalSaldoPendiente?.toLocaleString('es-CL') || '0'}
                                    </td>
                                    <td className="py-3 px-3 text-center">
                                        <div className="flex justify-center space-x-1">
                                            <button onClick={() => handleViewDetails(cliente.rut)}
                                                className="bg-yellow-500 text-white rounded-md p-1.5 hover:bg-yellow-600" 
                                                title="Ver detalles">
                                                <FontAwesomeIcon icon={faEye} />
                                            </button>
                                            <button
                                                onClick={() => handleEditClick(cliente)}
                                                className="bg-blue-500 text-white rounded-md p-1.5 hover:bg-blue-600"
                                                title="Editar cliente"
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(cliente._id)}
                                                className="bg-red-500 text-white rounded-md p-1.5 hover:bg-red-600"
                                                title="Eliminar cliente"
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal de resumen de carga */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Resumen de la Carga"
                className="modal"
                overlayClassName="modal-overlay"
            >
                <div className="relative p-4 bg-white rounded-lg shadow-lg">
                    <button onClick={closeModal} className="absolute top-2 right-2 text-gray-600 hover:text-gray-800">
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <h2 className="text-xl font-medium mb-3">Resumen de la Carga</h2>
                    <div className="overflow-y-auto max-h-96">
                        {/* Resultados exitosos */}
                        {resumenCarga?.resultados.length > 0 && (
                            <div className="mt-3">
                                <h3 className="font-medium text-green-600">Clientes Creados:</h3>
                                <ul className="list-disc list-inside">
                                    {resumenCarga.resultados.map((resultado, idx) => (
                                        <li key={idx}>
                                            Línea {resultado.linea}: {resultado.mensaje}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {/* Advertencias */}
                        {resumenCarga?.advertencias.length > 0 && (
                            <div className="mt-3">
                                <h3 className="font-medium text-yellow-600">Advertencias:</h3>
                                <ul className="list-disc list-inside">
                                    {resumenCarga.advertencias.map((advertencia, idx) => (
                                        <li key={idx}>
                                            Línea {advertencia.linea}: {advertencia.mensaje}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {/* Errores */}
                        {resumenCarga?.errores.length > 0 && (
                            <div className="mt-3">
                                <h3 className="font-medium text-red-600">Errores:</h3>
                                <ul className="list-disc list-inside">
                                    {resumenCarga.errores.map((error, idx) => (
                                        <li key={idx}>
                                            Línea {error.linea}: {error.mensaje}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>

            {/* Modal de edición */}
            {selectedCliente && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-4 rounded shadow-lg w-full max-w-md">
                        <h3 className="text-lg font-medium mb-3">Editar Cliente</h3>
                        {/* Formulario de edición */}
                        <form onSubmit={handleUpdateCliente}>
                            <label className="block mb-2">
                                Nombre:
                                <input
                                    type="text"
                                    value={selectedCliente.nombre}
                                    onChange={(e) => setSelectedCliente({ ...selectedCliente, nombre: e.target.value })}
                                    className="border border-gray-300 p-2 rounded w-full mt-1"
                                />
                            </label>
                            <label className="block mb-2">
                                RUT:
                                <input
                                    type="text"
                                    value={selectedCliente.rut}
                                    onChange={(e) => setSelectedCliente({ ...selectedCliente, rut: e.target.value })}
                                    className="border border-gray-300 p-2 rounded w-full mt-1"
                                />
                            </label>
                            <label className="block mb-2">
                                DIRECCIÓN:
                                <input
                                    type="text"
                                    value={selectedCliente.direccion}
                                    onChange={(e) => setSelectedCliente({ ...selectedCliente, direccion: e.target.value })}
                                    className="border border-gray-300 p-2 rounded w-full mt-1"
                                />
                            </label>
                            <label className="block mb-2">
                                EMAIL:
                                <input
                                    type="text"
                                    value={selectedCliente.email}
                                    onChange={(e) => setSelectedCliente({ ...selectedCliente, email: e.target.value })}
                                    className="border border-gray-300 p-2 rounded w-full mt-1"
                                />
                            </label>
                            <div className="flex justify-between mt-4">
                                <button
                                    type="button"
                                    onClick={() => setSelectedCliente(null)}
                                    className="bg-gray-500 text-white px-3 py-1 rounded"
                                >
                                    Cancelar
                                </button>
                                <button type="submit" className="bg-blue-500 text-white px-3 py-1 rounded">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClienteManager;
